import { call, take } from 'redux-saga/effects';

import { PREP_SCRIBE_FOR_EDITOR_SUCCESS } from 'js/actionCreators/scribeActions';

import { incrementEventSuperProperty, incrementUserProperties, track } from '../mixpanelProvider';

export function* trackServicesTemplateLoadedSaga(baseEventProperties) {
  const { scribe } = yield take(PREP_SCRIBE_FOR_EDITOR_SUCCESS);

  const imageElements = scribe.elements.filter(element => element.type === 'Image');
  const numberOfImages = imageElements.length;
  const audioClips = scribe.audioClips ?? [];
  const numberOfAudio = audioClips.length;

  yield call(track, 'Template Loaded', {
    ...baseEventProperties,
    'Scribe ID': scribe.id,
    'Number of Images': numberOfImages,
    'Audio Exists': numberOfAudio > 0
  });
  yield call(track, 'Edit Template', {
    ...baseEventProperties,
    'Scribe ID': scribe.id
  });
  yield call(incrementUserProperties, {
    'Total Scribes Created': 1,
    'Templates Opened': 1
  });
  yield call(incrementEventSuperProperty, 'Total Scribes Created');
  yield call(incrementEventSuperProperty, 'Templates Opened');
}
